import AppointmentTypeDto from 'common/dto-types/appointment-type-dto';

const AppointmentTypeCell = ({ value }: { value: AppointmentTypeDto }): JSX.Element => {
    if (!value) return <></>;

    return <p>{value.name}</p>;
};

export default AppointmentTypeCell;
